import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {compact, get} from 'lodash';
import {ROUTES} from '@app/store/routes';

const allowedLocations = (loc, roles) => {
  const foundLoc = ROUTES.find((item) => {
    let matched = item.path === loc;
    if (!matched) {
      // then check :params
      const tmp1 = item.path.split('/');
      const tmp2 = loc.split('/');
      tmp1.map((key, index) => {
        if (key.indexOf(':') >= 0) {
          tmp1[index] = null;
          tmp2[index] = null;
        }
        return key;
      });
      matched =
        compact(tmp1).join('/') === compact(tmp2).join('/') ? true : false;
    }
    return matched;
  });

  if (foundLoc && foundLoc.roles.find((item) => roles.includes(item))) {
    return true;
  }
  return false;
};

const PrivateRoute = ({children, ...rest}) => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const currentUser = useSelector((state) => state.auth.currentUser);

  return (
    <Route
      {...rest}
      render={({location}) => {
        const roles = get(currentUser, 'Roles', []);
        const isLocationAllowed = allowedLocations(location.pathname, roles);
        if (isLoggedIn) {
          if (isLocationAllowed) {
            return children;
          }
          return <Redirect to={{pathname: '/'}} />;
        }
        return (
          <Redirect
            to={{
              pathname: '/login',
              state: {from: location},
            }}
          />
        );
      }}
    />
  );
};

export default PrivateRoute;
